import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupDriver } from "../../../Shared/NewForms/NFLookupDriver";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { NFLookupUser } from "../../../Shared/NewForms/NFLookupUser";

const DeviceDetailMain = () => {
 
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={"Name"} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={"Unique code"} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput title="createdDate" fieldName="createdDate" />
        </Col>
        <Col sm={6}>
          <NFLookupInput title={"Products"} fieldName={"deviceType"} items={EnumHelper.ProductionTypeEnum()} />{" "}
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFLookupDriver title="driverId" fieldName="driverId" />
        </Col>
        <Col sm={6}>
          <NFLookupUser title="userId" fieldName="userId" />
        </Col>
      </Row>
    </>
  );
};

export default DeviceDetailMain;
